// extracted by mini-css-extract-plugin
export default {"formContainer":"horizontal-form-input-field_formContainer__+uJic","label":"horizontal-form-input-field_label__ODrZC","input":"horizontal-form-input-field_input__YaW4Z"};